import { LESSONS_PAGE_SIZE } from '@yandex-int/k-common/constants';

export const START_LESSON_PAGE = 1;
// при бесконечном скролле красивее начинать грузить следующий чанк, когда на экране появляется
// не ПОСЛЕДНИЙ элемент, а примерно за четверть до конца
const LOADING_BREAKPOINT = 0.25;
export const LOADING_BREAKPOINT_INDEX = Math.floor(LESSONS_PAGE_SIZE * LOADING_BREAKPOINT);
